
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ElementObjectExtra from './ElementObjectExtra';
import { VfbElement } from './Element';

@Component({
  components: {
    ElementObjectExtra,
  },
})
export default class VueFormBuilder extends Vue {
  @Prop({ required: true })
  readonly value!: string;

  builderElement: VfbElement | null = null;

  private lastEmittedValue: string | null = null;

  @Watch('value', { immediate: true }) //immediate: also call this function on initial value set
  onValueChanged(newValue: string, oldValue: string) {
    if (newValue === oldValue) {
      return;
    }

    //don't reparse the value if we just emitted it, otherwise everything may be rerendered which costs performance; also stops circular propagation
    if (newValue === this.lastEmittedValue) {
      return;
    }

    this.builderElement = null; //reset in case the following code crashes

    const parsed = JSON.parse(newValue);
    const element: VfbElement = { type: 'object', name: '', schema: parsed };

    //convert list objects to array to allow (re)ordering of elements
    const convertLists = (value: VfbElement) => {
      if (value.type === 'object') {
        value.schema = [...Object.values(value.schema)];
        value.schema.forEach((e: VfbElement) => convertLists(e));
      } else if (value.type === 'list') {
        convertLists(value.element);
      }
    };
    convertLists(element);

    this.builderElement = element;
  }

  @Watch('builderElement', { deep: true }) //deep: watch the complete object tree
  onBuilderElementChanged(newValue: VfbElement | null, oldValue: VfbElement | null) {
    let emitValue = newValue ?? { type: 'object', name: '', schema: [] } as VfbElement;
    emitValue = JSON.parse(JSON.stringify(emitValue)); // deep copy

    //convert list arrays back to objects
    const convertLists = (value: VfbElement) => {
      if (value.type === 'object') {
        value.schema.forEach((e: VfbElement) => convertLists(e));
        value.schema = Object.fromEntries(value.schema.map(e => [e.name, e]));
      } else if (value.type === 'list') {
        convertLists(value.element);
      }
    };
    convertLists(emitValue);

    const emitValueString = JSON.stringify(emitValue.schema);
    if (emitValueString !== this.value && emitValueString !== this.lastEmittedValue) {
      this.lastEmittedValue = emitValueString;
      this.$emit('input', emitValueString);
    }
  }
}
